// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type {
    GetVocAutoMateTasksMonitorByTaskTypeParam,
    BaseResponseListVocAutoMateMessageFoundResponse,
} from '../../../types';

/**
 * findAllMessage
 *
 * @export
 * @tags voc自动化配置
 * @link [GET] /vocAutoMateTasks/monitor/{taskType}
 * @param taskType
 */
export function getVocAutoMateTasksMonitorByTaskType(
    options: ApiOptions<GetVocAutoMateTasksMonitorByTaskTypeParam, never> & {
        segments: GetVocAutoMateTasksMonitorByTaskTypeParam;
    }
): Promise<BaseResponseListVocAutoMateMessageFoundResponse> {
    return request<never, GetVocAutoMateTasksMonitorByTaskTypeParam, never>(
        '/vocAutoMateTasks/monitor/{taskType}',
        { ...options, method: 'get', __$requestCalleeName: 'getVocAutoMateTasksMonitorByTaskType' }
    );
}

export const meta = [
    { tags: ['voc自动化配置'], path: '/vocAutoMateTasks/monitor/{taskType}', method: 'get' },
];
